import { useState } from 'react';
import * as S from './style'
//icons
import { SealPercent, Trash, Tag } from "@phosphor-icons/react";
//hooks
import { useMultipleModal } from '../../hooks/useMultipleModal';
//components
import CreatePromotion from '../../components/Modals/Promotion/Create';
import DeleteAll from '../../components/Modals/DeleteAll';
import BarcodeExport from '../../components/BarcodePng';

interface ITopActionBar {
    idSelecteds: number[];
    typeProduct: string;

    urlFilter?: {};
    fetchData: () => void;
    nameDeleteAll: string;
    handleDeleteResponse: (status: number) => void;
    isPromo?: boolean,
    isTag?: boolean,
    itemsTag?: {
        barcode: string,
        code: string,
        brands?: string,
        price: string
    }[];
}

export default function TopActionBar({
    idSelecteds,
    typeProduct,
    urlFilter,
    fetchData,
    nameDeleteAll,
    handleDeleteResponse,
    isPromo = true,
    isTag = false,
    itemsTag = []
}: ITopActionBar) {

    const [hoveredButton, setHoveredButton] = useState<string | null>(null);
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();

    const DeleteAllModal = () => {
        toggleModalVisibility("deleteAll");
    };

    return (
        <S.Container>
            <S.Button
                isActive={true}
                onMouseEnter={() => setHoveredButton("delete")}
                onMouseLeave={() => setHoveredButton(null)}
                onClick={DeleteAllModal}
            >
                {hoveredButton === "delete" ? <Trash size={24} weight="fill" /> : <Trash size={24} />}
                <S.Title>Excluir</S.Title>
            </S.Button>

            {
                isPromo && (
                    <S.Button
                        isActive={false}
                        onMouseEnter={() => setHoveredButton("promo")}
                        onMouseLeave={() => setHoveredButton(null)}
                        onClick={() => {
                            toggleModalVisibility('open-promotion');
                            setHoveredButton("promo");
                        }}
                    >
                        {hoveredButton === "promo" ? <SealPercent size={24} weight="fill" /> : <SealPercent size={24} />}
                        <S.Title>Promoção</S.Title>
                    </S.Button>
                )
            }
            {
                isTag && (
                    <S.Button
                        isActive={false}
                        onMouseEnter={() => setHoveredButton("tag")}
                        onMouseLeave={() => setHoveredButton(null)}
                        onClick={() => {
                            toggleModalVisibility('barcode');
                            setHoveredButton("tag");
                        }}
                    >
                        {hoveredButton === "tag" ? <Tag size={24} weight="fill" /> : <Tag size={24} />}
                        <S.Title>Etiqueta</S.Title>
                    </S.Button>
                )
            }

            {
                urlFilter &&
                <CreatePromotion
                    isOpenModalAcessory={isOpenModal("open-promotion")}
                    setModalClose={() => toggleModalVisibility("open-promotion")}

                    idProducts={idSelecteds}
                    type_product={typeProduct}
                    urlProduct={urlFilter}
                />
            }

            <DeleteAll
                setResponse={handleDeleteResponse}
                updateList={fetchData}
                data={idSelecteds}
                endpoint={nameDeleteAll}
                isOpenModal={isOpenModal("deleteAll")}
                setModalClose={() => toggleModalVisibility("deleteAll")}
            />

            <BarcodeExport
                isOpenBarcode={isOpenModal("barcode")}
                setModalClose={() => toggleModalVisibility("barcode")}
                itemsTag={itemsTag}
            />
        </S.Container>
    )
}